module.exports = __webpack_public_path__ + "static/img/star_collection.ad911168.png";